import { render } from "./DialogCancelComplete.vue?vue&type=template&id=ddc4803c&scoped=true"
import script from "./DialogCancelComplete.vue?vue&type=script&lang=js"
export * from "./DialogCancelComplete.vue?vue&type=script&lang=js"

import "./DialogCancelComplete.vue?vue&type=style&index=0&id=ddc4803c&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddc4803c"]])

export default __exports__